import { FC } from 'react';
import Link from 'next/link';
import ImgFullLabel from '../img-full-label/ImgFullLabel';
import { getAuthorFullName } from '@/helpers/helpers';
import { hideImgOnError } from '@/helpers/helpers';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import { IPopularBooks } from '@/interfaces/popularBooks.interface';
import styles from './HomePopularBooks.module.scss';

interface IHomePopularBooks {
  popularBooks: IPopularBooks;
}

const HomePopularBooks: FC<IHomePopularBooks> = ({ popularBooks }) => {
  return (
    <>
      {popularBooks.length > 0 && (
        <>
          <div className="contentHeader">
            <div className="contentHeader__item">
              <b>Топ 10 лучших книг</b>
            </div>
          </div>
          <div className="content">
            <div className={styles.popularBooks}>
              {popularBooks.map((book, index) => {
                const bookFullALias = `/authors/${book.author.alias}/${book.alias}/read}`;
                return (
                  <div key={`${book.id}-${index}`} className={index > 3 ? `${styles.popularBooks__item} ${styles.popularBooks__item_mob}` : `${styles.popularBooks__item}`}>
                    <div className={styles.popularBooks__wrap}>
                      <div className={styles.popularBooks__itemImgWrap}>
                        <Link prefetch={false} href={bookFullALias} className={styles.popularBooks__itemImg}>
                          <img className={styles.popularBooks__img} src={`${DEV_ABSOLUTE_URL}/covers/${book.external_id}.jpg`} alt="img" onError={hideImgOnError} width={76} height={110} />
                          {/* {book.book.allow_full_free === 1 && <ImgFullLabel />} */}
                        </Link>
                      </div>
                      <div className={styles.popularBooks__desc}>
                        <div className={styles.popularBooks__titleWrap}>
                          <Link prefetch={false} href={bookFullALias} className={styles.popularBooks__title}>
                            {book.title}
                          </Link>
                        </div>
                        <div>
                          <Link prefetch={false} href={`/authors/${book.author.alias}`} className={styles.popularBooks__link}>
                            {getAuthorFullName(book.author.first_name, book.author.middle_name, book.author.last_name)}
                          </Link>
                          <Link prefetch={false} href={`/genres/${book.genres[0].alias}`} className={styles.popularBooks__link}>
                            {book.genres[0].title}
                          </Link>
                          {/* <span className={styles.popularBooks__visited}>{book.views_count}</span> */}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className={styles.topBooksLinks}>
              <Link prefetch={false} className="allBooksLink allBooksLink_top" href="/tops">
                Все топы библиотеки
              </Link>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default HomePopularBooks;
